import script from "./ModalExportSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalExportSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./ModalExportSuccess.vue?vue&type=style&index=0&id=56a2695e&lang=scss"

const __exports__ = script;

export default __exports__